<template>
    <div class="prescription-summary">
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Prescription ID</b>
            </div>
            <div class="prescription-summary-content">
                {{prescriptionId}}
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Patient Name</b>
            </div>
            <div class="prescription-summary-content">
                {{patientName ? patientName: '-'}}
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Doctor Name</b>
            </div>
            <div class="prescription-summary-content">
                {{doctorName ? doctorName: '-'}}
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Prescription Date</b>
            </div>
            <div class="prescription-summary-content">
                {{dateTimeDisplay}}
            </div>
        </div>
        <div v-if="prescriptionType === 'Telemedicine Doctor Consultation'" class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Prescription Valid Until</b>
            </div>
            <div class="prescription-summary-content">
                {{prescriptionValidUntilDisplay}}
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Special Reminders</b>
            </div>
            <div class="prescription-summary-content">
                {{prescriptionSpecialReminderDisplay}}
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Prescription Status</b>
            </div>
            <div class="prescription-summary-content">
                <prescription-status :statusId="prescriptionStatus"></prescription-status>
            </div>
        </div>
        <div class="prescription-summary-row">
            <div class="prescription-summary-title">
                <b>Prescription Type</b>
            </div>
            <div class="prescription-summary-content">
                {{prescriptionType}}
            </div>
        </div>
        <template v-if="isUploadedPrescription">
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Uploaded File</b>
                </div>
                <div class="prescription-summary-content">
                    <a :href="uploadedFilePath" target="_blank" class="btn btn-primary btn-primary-insv">Download File</a>
                </div>
            </div>
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Upload Remarks</b>
                </div>
                <div class="prescription-summary-content">
                    {{uploadRemarksDisplay}}
                </div>
            </div>
        </template>
        <template v-if="isPharmacy && !isUploadedPrescription">
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Download Prescription</b>
                </div>
                <div class="prescription-summary-content">
                    <a :href="downloadPrescriptionPath" target="_blank" class="btn btn-primary btn-primary-insv">Download Prescription</a>
                </div>
            </div>
        </template>
        <template v-if="isDelivered">
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Delivery Company</b>
                </div>
                <div class="prescription-summary-content">
                    {{deliveryProvider}}
                </div>
            </div>
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Tracking Code</b>
                </div>
                <div class="prescription-summary-content">
                    {{deliveryTrackingCode ? deliveryTrackingCode : '-'}}
                </div>
            </div>
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Delivery Tracking Web Address</b>
                </div>
                <div class="prescription-summary-content">
                    <a v-if="deliveryTrackingWebAddress" :href="deliveryTrackingWebAddress" target="_blank">{{deliveryTrackingWebAddress}}</a>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Attached Delivery Photo</b>
                </div>
                 <div class="prescription-summary-content">
                    <a v-if="downloadAttachmentPath" :href="downloadAttachmentPath" target="_blank" class="btn btn-primary btn-primary-insv">Download Photo</a>
                    <div v-else>-</div>
                </div>
            </div>
            <div v-if="isPatient" class="prescription-summary-row">
                <div class="prescription-summary-title">
                    <b>Remarks</b>
                </div>
                <div class="prescription-summary-content">
                    Medicine package has been mailed. It will reach your mailing address soon.
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import {
    apiPath
} from '@/config';
import prescriptionStatus from '@/components/prescription-status';
import {
    convertToUserReadableDate,
    replaceLineBreakInHtml
} from '@/utilities';
export default {
    'name': 'PrescriptionSummaryComponent',
    'components': {
        prescriptionStatus
    },
    'props': {
        'prescriptionId': {
            'type': String,
            'default': null
        },
        'doctorName': {
            'type': String,
            'default': null
        },
        'patientName': {
            'type': String,
            'default': null
        },
        'prescriptionDate': {
            'type': String,
            'default': null
        },
        'prescriptionSpecialReminder': {
            'type': String,
            'default': null
        },
        'prescriptionType': {
            'type': String,
            'default': null
        },
        'prescriptionStatus': {
            'type': Number,
            'default': 0
        },
        'isUploadedPrescription': {
            'type': Boolean,
            'default': false
        },
        'uploadedFileId': {
            'type': String,
            'default': ''
        },
        'uploadRemarks': {
            'type': String,
            'default': ''
        },
        'isDelivered': {
            'type': Boolean,
            'default': false
        },
        'deliveryProvider': {
            'type': String,
            'default': ''
        },
        'deliveryTrackingCode': {
            'type': String,
            'default': ''
        },
        'deliveryTrackingWebAddress': {
            'type': String,
            'default': ''
        },
        'attachedDeliveryPhoto': {
            'type': String,
            'default': ''
        },
        'isPatient': {
            'type': Boolean,
            'default': false
        },
        'isPharmacy': {
            'type': Boolean,
            'default': false
        },
        'prescriptionValidUntil': {
            'type': String,
            'default': null
        }
    },
    data () {
        return {
            apiPath
        };
    },
    'computed': {
        dateTimeDisplay () {
            return this.prescriptionDate ? convertToUserReadableDate(this.prescriptionDate) : '-';
        },
        uploadedFilePath () {
            return this.isUploadedPrescription
                ? `${apiPath}Prescription/DownloadUploadedPrescription?uploadId=${this.uploadedFileId}` : '';
        },
        uploadRemarksDisplay () {
            return this.uploadRemarks ? replaceLineBreakInHtml(this.uploadRemarks) : '-';
        },
        prescriptionValidUntilDisplay () {
            return this.prescriptionValidUntil ? convertToUserReadableDate(this.prescriptionValidUntil) : '-';
        },
        prescriptionSpecialReminderDisplay () {
            return this.prescriptionSpecialReminder ? replaceLineBreakInHtml(this.prescriptionSpecialReminder) : '-';
        },
        downloadPrescriptionPath () {
            return (!this.isUploadedPrescription && this.isPharmacy) ? `${apiPath}Prescription/Download?prescriptionIdShort=${this.prescriptionId}&token=${this.token}` : '';
        },
        downloadAttachmentPath () {
            return this.attachedDeliveryPhoto ? `${apiPath}Prescription/DownloadUploadedDeliveryAttachment?uploadId=${this.attachedDeliveryPhoto}&token=${this.token}` : '';
        },
        token () {
            return Cookies.get('t');
        }
    }
};

</script>

<style>
    .prescription-summary {}

    .prescription-summary .prescription-summary-row .prescription-summary-title {
        margin-bottom: .25rem;
    }

    @media(min-width: 576px) {
        .prescription-summary .prescription-summary-row {
            display: flex;
        }

        .prescription-summary .prescription-summary-row .prescription-summary-title {
            width: 200px;
            margin-bottom: 0;
            margin-right: 1.25rem;
        }

        .prescription-summary .prescription-summary-row .prescription-summary-content {
            display: flex;
            flex: 1;
        }
    }

    .prescription-summary .prescription-summary-row:not(:last-child) {
        margin-bottom: 1.25rem;
    }

    .prescription-summary-content p:last-child {
        margin-bottom: 0;
    }

</style>
